import { Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

/**
 * Service to handle navigation events and track the current URL.
 * @export
 * @class NavService
 */
@Injectable({ providedIn: 'root' })
export class NavService {

    /** @ignore */
    public currentUrl = new BehaviorSubject<any>(undefined);

    /** @ignore */
    constructor(private router: Router) {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.currentUrl.next(event.urlAfterRedirects);
            }
        });
    }
}